import Cookies from 'js-cookie';
import sa from 'sa-sdk-javascript';
import {getPlatform} from './platform';
import {getProjectInfo as getAppProjectInfo} from './app/api';

/**
 * to enable '神策'
 */
export default function (){
    sa.init({
        sdk_url: '//staticfile.hetao101.com/sensors/sensorsdata.min.js',
        name: 'sa',
        web_url: '//sensors.corp.hetao101.com/?project=production',
        server_url: '//sensors.hetao101.com/sa?project=production',
        show_log: false,
        heatmap: {
            // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
            clickmap: 'default',
            // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
            scroll_notice_map: 'not_collect'
        }
    });
    let userId = Cookies.get('userId') ? Cookies.get('userId') : 0;
    if (getPlatform() === 'APP') {
        userId = getAppProjectInfo().user_id;
    }
    sa.login(userId);
    sa.quick('autoTrack'); // 神策系统必须是1.4最新版及以上
    window.sa = sa;
}
